import EditorModal from './EditorModal.js';
import notification from 'notification-js';

let pageSections, flux;

const findByTag = (tagName) => {
  let elementData = JSON.search(pageSections, tagName);

  if (elementData.length === 1) {
    return pageSections['sections'][[Object.keys(elementData[0].chain.sections)[0]]];
  }

  return false;
}

const createModalContainer = () => {
  let modalContainer = document.createElement('div');
  modalContainer.id = "modals-container";
  modalContainer.className = "modals-container";
  document.body.appendChild(modalContainer);
}

const LoadEditor = (flux, path, data) => {
  let findElement = document.querySelectorAll('[data-cms-render="' + path[0] + '"]')[0];
  findElement.className += " editable";

  let editorModal = new EditorModal({type: data.type, path, flux, data});

  let editButton = document.createElement("a");
  editButton.innerHTML = "Edit";
  editButton.className = "editButton button";
  editButton.dataset.path = path[0];
  editButton.onclick = (event) => {
    event.preventDefault();
    let state = flux._stores.sections.state.get('sections').getIn(path).toJS();
    editorModal.open(state, flux);
  }

  editButton.style.top = findElement.offsetTop + 'px';

  document.getElementById('editPanel').appendChild(editButton);

  window.addEventListener('resizeend', function () {
    let editButtons = document.body.getElementsByClassName('editButton');

    for (var i = 0; i < editButtons.length; i++) {
      let path = editButtons[i].dataset.path;
      let findElement = document.querySelectorAll('[data-cms-render="' + path + '"]')[0];

      editButtons[i].style.top = findElement.offsetTop + 'px';
    }
  });
}

const revertSection = (path) => {
  let sectionData = JSON.search(pageSections, path[path.length - 1]);

  if (sectionData.length === 1) {
    sectionData = pageSections['sections'][[Object.keys(sectionData[0].chain.sections)[0]]];

    if (sectionData.type !== "container") {
      flux.getActions('sections').updateSection(path.join(" "), sectionData);
    } else {
      sectionData.sections.forEach((section) => {
        if (section.tags.indexOf(path[path.length -1 ]) > -1) {
          flux.getActions('sections').updateSection(path.join(" "), section);
        }
      });
    }

  }
}

const revertSections = (sections, path) => {
  sections.forEach((section, key) => {
    if (section.get('sections')) {
      return revertSections(section.get('sections'), [key]);
    }

    let storePath = (path) && path.slice(0);
    (storePath) ? storePath.push(key) : storePath = [key];
    revertSection(storePath);
  });
}

const revert = () => {
  revertSections(flux._stores.sections.state.get('sections'));
}

const loadEditorStyles = (flux) => {
  let editorCSS = document.createElement("link");
  editorCSS.setAttribute("rel", "stylesheet");
  editorCSS.setAttribute("type", "text/css");
  editorCSS.setAttribute("href", "styles/editor.css");
  document.getElementsByTagName("head")[0].appendChild(editorCSS);

  let saveButton = document.createElement("a");
  saveButton.innerHTML = "Save";
  saveButton.id = "save";
  saveButton.className = "saveButton button";
  saveButton.onclick = (event) => {
    event.preventDefault();
    revertButton.style.display = 'none';
    saveButton.innerHTML = "Saving...";
    flux.getActions('sections').saveState(flux._stores.sections);
  }

  let revertButton = document.createElement("a");
  revertButton.innerHTML = "Revert";
  revertButton.id = "revert";
  revertButton.className = "revertButton button";
  revertButton.onclick = (event) => {
    event.preventDefault();
    revert(flux);
    revertButton.style.display = 'none';
    saveButton.style.display = 'none';
  }

  let editPanel = document.createElement("div");
  editPanel.id = "editPanel";
  editPanel.className = "editPanel";

  editPanel.onmouseover = () => {
    let editButtons = document.getElementsByClassName('editButton');

    for (var i = 0, max = editButtons.length; i < max; i++) {
      editButtons[i].style.display = 'block';
    }
  }

  editPanel.onmouseout = () => {
    let editButtons = document.getElementsByClassName('editButton');

    for (var i = 0, max = editButtons.length; i < max; i++) {
      editButtons[i].style.display = 'none';
    }
  }

  let resizeElement = document.body,
      resizeCallback = function() {
        editPanel.style.height = document.body.offsetHeight + 'px';
      };
  addResizeListener(resizeElement, resizeCallback);

  document.body.appendChild(saveButton);
  document.body.appendChild(revertButton);
  document.body.appendChild(editPanel);
}

const CheckEditorLoad = (section, path, flux) => {
  path = (path.constructor === Array) ? path : [path];

  if (section.get("sections")) {
    return section.get("sections").forEach((section, childPath) => {
      path.push(childPath);
      CheckEditorLoad(section, path, flux);
    });
  }

  if (path.length > 1) {
    path.splice(1, 0, "sections");
  }

  path.splice(0,0, "previousSections");
  let previousSection = flux._stores.sections.state.getIn(path);

  if (!previousSection) {
    path.shift();
    LoadEditor(flux, path, section.toJS())
  }
}

export default(fluxData, originalJSON) => {
  pageSections = originalJSON;
  flux = fluxData;
  createModalContainer();
  loadEditorStyles(flux);

  flux._stores.sections.on('change', () => {
    let saveButton = document.getElementById("save");
    let revertButton = document.getElementById("revert");

    if (flux._stores.sections.state.get('isSaved')) {
      if (saveButton.style.display == 'block') {
        notification.notify( 'success', 'Page has been saved', {
          notification: {position: [ 'right', 'top' ]}
        });
      }

      saveButton.style.display = 'none';
      revertButton.style.display = 'none';
      saveButton.innerHTML = 'Save';
    } else {
      saveButton.style.display = 'block';
      revertButton.style.display = 'block';
    }

    flux._stores.sections.state.get('sections').forEach((section, path) => {
      CheckEditorLoad(section, path, flux)
    });
  });
};

(function(doc, proto) {
  try { // check if browser supports :scope natively
    doc.querySelector(':scope body');
  } catch (err) { // polyfill native methods if it doesn't
    ['querySelector', 'querySelectorAll'].forEach(function(method) {
      var nativ = proto[method];
      proto[method] = function(selectors) {
        if (/(^|,)\s*:scope/.test(selectors)) { // only if selectors contains :scope
          var id = this.id; // remember current element id
          this.id = 'ID_' + Date.now(); // assign new unique id
          selectors = selectors.replace(/((^|,)\s*):scope/g, '$1#' + this.id); // replace :scope with #ID
          var result = doc[method](selectors);
          this.id = id; // restore previous id
          return result;
        } else {
          return nativ.call(this, selectors); // use native code for other selectors
        }
      }
    });
  }
})(window.document, Element.prototype);



// WEBPACK FOOTER //
// ./src/Editor.js